import { default as commentsITiwbEFzn3Meta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/comments.vue?macro=true";
import { default as controlPanel4OGuODJGqyMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/controlPanel.vue?macro=true";
import { default as errorsiGKh3vJUFpMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/errors.vue?macro=true";
import { default as feedbackcv2rxCNZ2KMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/feedback.vue?macro=true";
import { default as indexYCuqeocIpNMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/index.vue?macro=true";
import { default as logindvyygmwnEjMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/login.vue?macro=true";
import { default as newsTPA81foN0dMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/news.vue?macro=true";
import { default as noticeBoardqxLWKULDaaMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/noticeBoard.vue?macro=true";
import { default as preferencesaJMscc4gDvMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/preferences.vue?macro=true";
import { default as questionsDQx6buemxdMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/questions.vue?macro=true";
import { default as setsZb1cpb1QqfMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/sets.vue?macro=true";
import { default as indexqAuoIxMNFoMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/surveys/[semester]/[id]/index.vue?macro=true";
import { default as indexxQXVZHpkhgMeta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/surveys/index.vue?macro=true";
import { default as usershe5XZhPZz7Meta } from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/users.vue?macro=true";
export default [
  {
    name: commentsITiwbEFzn3Meta?.name ?? "comments___cs",
    path: commentsITiwbEFzn3Meta?.path ?? "/comments",
    meta: commentsITiwbEFzn3Meta || {},
    alias: commentsITiwbEFzn3Meta?.alias || [],
    redirect: commentsITiwbEFzn3Meta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/comments.vue").then(m => m.default || m)
  },
  {
    name: controlPanel4OGuODJGqyMeta?.name ?? "controlPanel___cs",
    path: controlPanel4OGuODJGqyMeta?.path ?? "/controlPanel",
    meta: controlPanel4OGuODJGqyMeta || {},
    alias: controlPanel4OGuODJGqyMeta?.alias || [],
    redirect: controlPanel4OGuODJGqyMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/controlPanel.vue").then(m => m.default || m)
  },
  {
    name: errorsiGKh3vJUFpMeta?.name ?? "errors___cs",
    path: errorsiGKh3vJUFpMeta?.path ?? "/errors",
    meta: errorsiGKh3vJUFpMeta || {},
    alias: errorsiGKh3vJUFpMeta?.alias || [],
    redirect: errorsiGKh3vJUFpMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/errors.vue").then(m => m.default || m)
  },
  {
    name: feedbackcv2rxCNZ2KMeta?.name ?? "feedback___cs",
    path: feedbackcv2rxCNZ2KMeta?.path ?? "/feedback",
    meta: feedbackcv2rxCNZ2KMeta || {},
    alias: feedbackcv2rxCNZ2KMeta?.alias || [],
    redirect: feedbackcv2rxCNZ2KMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/feedback.vue").then(m => m.default || m)
  },
  {
    name: indexYCuqeocIpNMeta?.name ?? "index___cs",
    path: indexYCuqeocIpNMeta?.path ?? "/",
    meta: indexYCuqeocIpNMeta || {},
    alias: indexYCuqeocIpNMeta?.alias || [],
    redirect: indexYCuqeocIpNMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: logindvyygmwnEjMeta?.name ?? "login___cs",
    path: logindvyygmwnEjMeta?.path ?? "/login",
    meta: logindvyygmwnEjMeta || {},
    alias: logindvyygmwnEjMeta?.alias || [],
    redirect: logindvyygmwnEjMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: newsTPA81foN0dMeta?.name ?? "news___cs",
    path: newsTPA81foN0dMeta?.path ?? "/news",
    meta: newsTPA81foN0dMeta || {},
    alias: newsTPA81foN0dMeta?.alias || [],
    redirect: newsTPA81foN0dMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/news.vue").then(m => m.default || m)
  },
  {
    name: noticeBoardqxLWKULDaaMeta?.name ?? "noticeBoard___cs",
    path: noticeBoardqxLWKULDaaMeta?.path ?? "/noticeBoard",
    meta: noticeBoardqxLWKULDaaMeta || {},
    alias: noticeBoardqxLWKULDaaMeta?.alias || [],
    redirect: noticeBoardqxLWKULDaaMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/noticeBoard.vue").then(m => m.default || m)
  },
  {
    name: preferencesaJMscc4gDvMeta?.name ?? "preferences___cs",
    path: preferencesaJMscc4gDvMeta?.path ?? "/preferences",
    meta: preferencesaJMscc4gDvMeta || {},
    alias: preferencesaJMscc4gDvMeta?.alias || [],
    redirect: preferencesaJMscc4gDvMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/preferences.vue").then(m => m.default || m)
  },
  {
    name: questionsDQx6buemxdMeta?.name ?? "questions___cs",
    path: questionsDQx6buemxdMeta?.path ?? "/questions",
    meta: questionsDQx6buemxdMeta || {},
    alias: questionsDQx6buemxdMeta?.alias || [],
    redirect: questionsDQx6buemxdMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/questions.vue").then(m => m.default || m)
  },
  {
    name: setsZb1cpb1QqfMeta?.name ?? "sets___cs",
    path: setsZb1cpb1QqfMeta?.path ?? "/sets",
    meta: setsZb1cpb1QqfMeta || {},
    alias: setsZb1cpb1QqfMeta?.alias || [],
    redirect: setsZb1cpb1QqfMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/sets.vue").then(m => m.default || m)
  },
  {
    name: indexqAuoIxMNFoMeta?.name ?? "surveys-semester-id___cs",
    path: indexqAuoIxMNFoMeta?.path ?? "/surveys/:semester()/:id()",
    meta: indexqAuoIxMNFoMeta || {},
    alias: indexqAuoIxMNFoMeta?.alias || [],
    redirect: indexqAuoIxMNFoMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/surveys/[semester]/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexxQXVZHpkhgMeta?.name ?? "surveys___cs",
    path: indexxQXVZHpkhgMeta?.path ?? "/surveys",
    meta: indexxQXVZHpkhgMeta || {},
    alias: indexxQXVZHpkhgMeta?.alias || [],
    redirect: indexxQXVZHpkhgMeta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/surveys/index.vue").then(m => m.default || m)
  },
  {
    name: usershe5XZhPZz7Meta?.name ?? "users___cs",
    path: usershe5XZhPZz7Meta?.path ?? "/users",
    meta: usershe5XZhPZz7Meta || {},
    alias: usershe5XZhPZz7Meta?.alias || [],
    redirect: usershe5XZhPZz7Meta?.redirect,
    component: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/pages/users.vue").then(m => m.default || m)
  }
]